import { WalletService } from "@/services/wallet.service";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const useFetchWalletData = ({ currency, enabled = true }: { currency: string; enabled?: boolean }) => {
  const { t } = useTranslation('common');

  const {
    data,
    isPending: isLoading,
    refetch,
    isRefetching,
    error,
  } = useQuery({
    queryKey: ['wallet-data', currency],
    queryFn: async () => {
      const [retention, totals] = await Promise.all([
        WalletService.getRetention(currency),
        WalletService.getTotalsWithdrawals(currency),
      ]);

      return { retention, totals };
    },
    enabled,
  });

  const retentionItems = data?.retention?.items || [];
  const retentionItem = retentionItems.find(
    (item) => item.type === 'retention'
  );
  const receivableItem = retentionItems.find(
    (item) => item.type === 'receivable'
  );

  return {
    anticipation: data?.retention,
    retention: retentionItems,
    retentionItem,
    receivableItem,
    totals: data?.totals,
    isLoading,
    refetch,
    // anticipation: receivableItem,
    isRefetching,
    error: error ? (error as Error).message || t('data_listing_error') : null,
  };
};
